export { default } from './AISummary';
export type { AISummaryProps } from './AISummary';
